import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

import 'vuetify/styles'               // Estilos do Vuetify
import './style.css'                 // Seus estilos customizados
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { createPinia } from 'pinia'
import '@mdi/font/css/materialdesignicons.css'


import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

import { inject } from '@vercel/analytics'
inject()

const app = createApp(App)
const pinia = createPinia()

// Inicialização do Sentry
Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration({ router })
  ],
  tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
  tracePropagationTargets: ['localhost', /^\//],
  release: import.meta.env.npm_package_version,
  environment: import.meta.env.MODE,
})

app
  .use(router)
  .use(vuetify)
  .use(Toast)
  .use(pinia)
  .mount('#app')